(function() {
  const section = document.querySelector('.advent-calendar[data-section-id]');
  if (!section) return;

  let loadingAnimationInterval;
  let currentPawStep = 0;
  const maxPaws = 6;
  let videoSkipped = false;
  let revealTransitionTimeout = null;
  let assetsLoaded = false;

  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

  const customCursorEnabled = section.dataset.customCursorEnabled === 'true';
  if (customCursorEnabled) {
    section.setAttribute('data-custom-cursor', 'enabled');
    const cursor = section.querySelector('.advent-calendar__custom-cursor');
    if (cursor) {
      document.addEventListener('mousemove', (e) => {
        cursor.style.left = e.clientX + 'px';
        cursor.style.top = e.clientY + 'px';
      });
    }
  }

  function startLoadingAnimation() {
    const paws = section.querySelectorAll('.advent-calendar__loading-paw');
    const dotsSpan = section.querySelector('.advent-calendar__loading-dots');

    if (!paws.length || !dotsSpan) return;

    loadingAnimationInterval = setInterval(() => {
      currentPawStep = (currentPawStep % maxPaws) + 1;

      paws.forEach((paw, index) => {
        if (index < currentPawStep) {
          paw.classList.add('active');
        } else {
          paw.classList.remove('active');
        }
      });

      dotsSpan.textContent = '.'.repeat(currentPawStep);
      if (assetsLoaded && currentPawStep === maxPaws) {
        stopLoadingAnimation();
        setTimeout(() => {
          setState('today-preview');
        }, 100);
      }
    }, 500);
  }

  function stopLoadingAnimation() {
    if (loadingAnimationInterval) {
      clearInterval(loadingAnimationInterval);
      loadingAnimationInterval = null;
    }
  }

  function preloadAssets() {
    const promises = [];

    const allImages = section.querySelectorAll('img[src]');
    allImages.forEach(img => {
      if (img.src && !img.complete) {
        promises.push(new Promise((resolve) => {
          const timeout = setTimeout(resolve, 7000);
          
          const tempImg = new Image();
          tempImg.onload = () => {
            clearTimeout(timeout);
            resolve();
          };
          tempImg.onerror = () => {
            clearTimeout(timeout);
            resolve();
          };
          tempImg.src = img.src;
        }));
      }
    });

    const videoSelector = isMobile()
      ? '.advent-calendar__reveal-video-mobile, .advent-calendar__fullscreen-video-mobile' 
      : '.advent-calendar__reveal-video-desktop, .advent-calendar__fullscreen-video-desktop';
      
    const videos = section.querySelectorAll(videoSelector);
    
    videos.forEach(video => {
      if (!video.currentSrc && !video.querySelector('source')) return;
      
      promises.push(new Promise((resolve) => {
        const timeout = setTimeout(() => {
          console.warn('Advent Calendar: Video preload timed out');
          resolve();
        }, 20000);

        const onReady = () => {
          if (video.readyState >= 3) {
             clearTimeout(timeout);
             cleanup();
             resolve();
          }
        };

        const cleanup = () => {
          video.removeEventListener('canplay', onReady);
          video.removeEventListener('canplaythrough', onReady);
          video.removeEventListener('loadeddata', onReady);
          video.removeEventListener('error', onError);
        };
        
        const onError = () => {
          clearTimeout(timeout);
          cleanup();
          resolve();
        };

        if (video.readyState >= 3) {
          clearTimeout(timeout);
          resolve();
          return;
        }

        video.addEventListener('canplay', onReady);
        video.addEventListener('canplaythrough', onReady);
        video.addEventListener('loadeddata', onReady);
        video.addEventListener('error', onError);
        video.muted = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('muted', '');
        
        video.load();
      }));
    });

    return Promise.all(promises);
  }

  function setState(newState) {
    const currentState = getState();
    const currentStateEl = section.querySelector(`[data-state-content="${currentState}"]`);
    const newStateEl = section.querySelector(`[data-state-content="${newState}"]`);
    
    if (currentState === newState) return;
    
    if (currentStateEl) {
      currentStateEl.classList.remove('fade-in');
      currentStateEl.classList.add('fade-out');
    }
    
    section.setAttribute('data-state', newState);
    
    if (newStateEl) {
      newStateEl.classList.remove('fade-out');
      
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          newStateEl.classList.add('fade-in');
          
          if (newState === 'today-preview') {
            const decorativeImages = newStateEl.querySelectorAll('.advent-calendar__decorative-image');
            decorativeImages.forEach(el => {
              if (el.classList.contains('prepare-entrance')) {
                el.classList.remove('prepare-entrance');
                el.classList.add('is-entering');
                el.addEventListener('animationend', () => {
                  el.classList.remove('is-entering');
                  el.classList.add('is-floating');
                }, { once: true });
              } else if (!el.classList.contains('is-floating') && !el.classList.contains('is-entering')) {
                 el.classList.add('is-floating');
              }
            });
          }
        });
      });
    }
  }

  function getState() {
    return section.getAttribute('data-state');
  }

  const todayImages = section.querySelectorAll('.advent-calendar__today-preview .advent-calendar__decorative-image');
  todayImages.forEach(el => el.classList.add('prepare-entrance'));

  section.querySelectorAll('.advent-calendar__decorative-image').forEach(el => {
    if (!el.closest('.advent-calendar__today-preview')) {
      el.classList.add('is-floating');
    }
  });

  startLoadingAnimation();
  
  const loadingEl = section.querySelector('[data-state-content="loading"]');
  if (loadingEl) {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        loadingEl.classList.add('fade-in');
      });
    });
  }

  if (document.readyState === 'complete') {
    preloadAssets().then(() => {
      assetsLoaded = true;
    });
  } else {
    window.addEventListener('load', () => {
      preloadAssets().then(() => {
        assetsLoaded = true;
      });
    });
  }

  const tapTarget = section.querySelector('[data-tap-target]');
  if (tapTarget) {
    tapTarget.addEventListener('click', (e) => {
      if(section.dataset.isAnimating === 'true') return;
      section.dataset.isAnimating = 'true';

      videoSkipped = false;

      const mobile = isMobile();
      const revealVideoSelector = mobile ? '.advent-calendar__reveal-video-mobile' : '.advent-calendar__reveal-video-desktop';
      const fullscreenVideoSelector = mobile ? '.advent-calendar__fullscreen-video-mobile' : '.advent-calendar__fullscreen-video-desktop';
      const revealVideo = section.querySelector(revealVideoSelector);
      const fullscreenVideo = section.querySelector(fullscreenVideoSelector);

      if (revealVideo) {
        revealVideo.muted = true;
        revealVideo.currentTime = 0;
        
        const playPromise = revealVideo.play();
        if (playPromise !== undefined) {
          playPromise.catch(error => {
            console.error("Reveal playback failed:", error);
          });
        }
      }

      setState('reveal-circle');
      void section.offsetHeight;
    
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const revealContainer = section.querySelector('.advent-calendar__reveal-video-container');
          if (revealContainer) {
            revealContainer.classList.add('expanded');

            const skipButtonReveal = section.querySelector('.advent-calendar__skip-button--reveal');
            if (skipButtonReveal) {
              skipButtonReveal.style.opacity = '1';
            }

            revealTransitionTimeout = setTimeout(() => {
              if (!videoSkipped) {
                setState('video-fullscreen');
                
                if (fullscreenVideo) {
                  if (revealVideo && !revealVideo.paused) {
                    fullscreenVideo.currentTime = revealVideo.currentTime;
                  }
                  
                  fullscreenVideo.muted = true;
                  const fsPlayPromise = fullscreenVideo.play();
                  if (fsPlayPromise !== undefined) {
                     fsPlayPromise.catch(e => console.log('Fullscreen play error', e));
                  }

                  fullscreenVideo.addEventListener('click', () => {
                    if (fullscreenVideo.muted && !videoSkipped) {
                      fullscreenVideo.muted = false;
                    }
                  });

                  const onVideoEnd = () => {
                    if (!videoSkipped) {
                      setState('activation');
                    }
                  };
                  fullscreenVideo.addEventListener('ended', onVideoEnd, { once: true });
                  fullscreenVideo.addEventListener('error', onVideoEnd, { once: true });
                } else {
                  if (!videoSkipped) {
                    setTimeout(() => {
                      setState('activation');
                    }, 500);
                  }
                }
              }
              section.dataset.isAnimating = 'false';
            }, 3000);
          } else {
            if (!videoSkipped) {
              setTimeout(() => {
                setState('activation');
              }, 500);
            }
          }
        });
      });
    });
  }

  const skipButtons = section.querySelectorAll('[data-skip-video]');
  skipButtons.forEach(skipButton => {
    skipButton.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      videoSkipped = true;
      
      if (revealTransitionTimeout) {
        clearTimeout(revealTransitionTimeout);
        revealTransitionTimeout = null;
      }
      
      section.querySelectorAll('video').forEach(v => {
        v.pause();
        v.currentTime = 0;
      });
      
      setState('activation');
      section.dataset.isAnimating = 'false';
    });
  });

  const closeButton = section.querySelector('[data-close-activation]');
  if (closeButton) {
    closeButton.addEventListener('click', () => {
      setState('activation-overview');
    });
  }

  const tapOverview = section.querySelector('[data-tap-overview]');
  if (tapOverview) {
    tapOverview.addEventListener('click', () => {
      setState('activation');
    });
  }

  const decorativeImages = section.querySelectorAll('.advent-calendar__decorative-image');
  const errorMessage = section.querySelector('.advent-calendar__error-message');
  let errorTimeout;

  decorativeImages.forEach(img => {
    img.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (!errorMessage) return;

      if (errorTimeout) {
        clearTimeout(errorTimeout);
      }

      errorMessage.classList.add('is-visible');

      errorTimeout = setTimeout(() => {
        errorMessage.classList.remove('is-visible');
      }, 3000);
    });
  });
})();
